export default __webpack_public_path__ + "app/public/asset/img/icon_CGI.jpg";